import api from './index'
import {
  axios
} from '@/utils/request'

/**
 * login func
 * parameter: {
 *     username: '',
 *     password: '',
 *     remember_me: true,
 *     captcha: '12345'
 * }
 * @param parameter
 * @returns {*}
 */
export function login(parameter) {
  const params = new URLSearchParams()
  params.append('username', parameter.username)
  params.append('password', parameter.password)
  params.append('grant_type', 'password')
  params.append('scope', 'all')
  return axios({
    url: '/sys/login',
    method: 'post',
    data: params,
    headers: {
      "Authorization": "Basic bWluaTptaW5pc2VjcmV0",
    }
  })
}

export function getSmsCaptcha(parameter) {
  return axios({
    url: api.SendSms,
    method: 'post',
    data: parameter
  })
}

export function getInfo() {
  return axios({
    url: '/api/user/info',
    method: 'get',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8'
    }
  })
}

export function logout(logoutToken) {
  return axios({
    url: '/sys/logout',
    method: 'post',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
      'Authorization': logoutToken
    }
  })
}